/**
 * Frontend constants — must stay in sync with backend enums.
 */

export const ROLES = {
  ADMIN: 'ADMIN',
  GA: 'GA',
  FINANCE: 'FINANCE',
  EXECUTIVE: 'EXECUTIVE',
  VIEWER: 'VIEWER',
};

export const ROLE_LABELS = {
  ADMIN: 'System Admin',
  GA: 'General Affairs',
  FINANCE: 'Finance',
  EXECUTIVE: 'Executive (BOD)',
  VIEWER: 'Viewer',
};

export const ASSET_STATUS = {
  ACTIVE: 'ACTIVE',
  IDLE: 'IDLE',
  DAMAGED: 'DAMAGED',
  UNDER_REPAIR: 'UNDER_REPAIR',
  RETIRED: 'RETIRED',
  LOST: 'LOST',
};

export const ASSET_TYPE = {
  STANDARD: 'STANDARD',
  STORAGE_UNIT: 'STORAGE_UNIT',
};

export const DRIVE_HEALTH = {
  OK: 'OK',
  BROKEN: 'Broken',
  NOT_DETECTED: 'Not Detected',
  DEAD: 'Dead',
};

export const PAYMENT_SOURCE = {
  CASH: 'Cash',
  CREDIT_CARD: 'Credit Card',
  INSTALLMENT: 'Installment',
  HIBAH: 'Hibah / Grant',
  OTHER: 'Other',
};

// Reasons an asset's data can't be fully trusted yet — mirrors the backend
// DataIssue enum. An asset with none is documented.
export const WARRANTY_FILTER_LABELS = {
  EXPIRING_SOON: 'Expiring within 30 days',
  EXPIRED_RECENT: 'Expired in last 14 days',
  EXPIRED_LONG: 'Expired over 14 days ago',
  NONE: 'No warranty date',
};

export const DATA_ISSUE_LABELS = {
  INVOICE_PENDING: 'Invoice pending',
  ENTITY_UNCONFIRMED: 'Entity unconfirmed',
  DATE_UNCONFIRMED: 'Date unconfirmed',
  PRICE_UNCONFIRMED: 'Price unconfirmed',
  NEEDS_REVIEW: 'Needs review',
};

// Derived (never stored) list of record fields that are still empty.
export const MISSING_FIELD_LABELS = {
  purchaseDate: 'Original acquisition date',
  purchasePrice: 'Original acquisition price',
  entityPurchaseDate: 'Entity acquisition date',
  entityPurchasePrice: 'Entity acquisition price',
  invoiceNumber: 'Invoice reference',
};

// What Finance reads from ownership + the installment plan. The class itself is
// derived by the backend (utils/assetOwnership.js); these are only its labels.
export const OWNERSHIP_CLASS_LABELS = {
  PAID_OFF: 'Fully Owned – Paid Off',
  UNDER_INSTALLMENT: 'Fully Owned – Under Installment',
  RENTED_LEASED: 'Rented / Leased',
};

export const OWNERSHIP_OPTIONS = [
  { value: 'OWNED', label: 'Owned' },
  { value: 'RENTED_LEASED', label: 'Rented / Leased' },
];

